import { MarkerOdComponent } from "./marker-od/marker-od.component";
import { MarkerStopDisabledComponent } from "./marker-stop-disabled/marker-stop-disabled.component";
import { MarkerStopComponent } from "./marker-stop/marker-stop.component";
import { MarkerVehicleComponent } from "./marker-vehicle/marker-vehicle.component";

export {
  MarkerOdComponent,
  MarkerStopComponent,
  MarkerStopDisabledComponent,
  MarkerVehicleComponent,
};

export const markers = [
  MarkerStopDisabledComponent,
]
